import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import React, { useEffect, useMemo, useState } from 'react'
import { checkValidFormFieldValue } from '../../utils/helper'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../constants'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { toJS } from 'mobx'

const { RangePicker } = DatePicker
const { Option } = Select

const BoardResolutionMinutesPageAdvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)

  const { boardResolutionMinutesStore } = props
  const { filterBoardHDQT } = boardResolutionMinutesStore
  const [form] = Form.useForm()

  const values = Form.useWatch([], form)
  const { setFieldsValue } = form
  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(filterBoardHDQT?.document_name)) count++
    if (hasValue(filterBoardHDQT?.document_number)) count++
    if (hasValue(filterBoardHDQT?.issue_level)) count++
    if (hasValue(filterBoardHDQT?.contruction_board)) count++
    if (hasValue(filterBoardHDQT?.status)) count++

    if (filterBoardHDQT?.from_issue_date || filterBoardHDQT?.to_issue_date)
      count++

    return count
  }, [filterBoardHDQT])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        document_name: filterBoardHDQT?.document_name,
        document_number: filterBoardHDQT?.document_number,
        issue_level: filterBoardHDQT?.issue_level,
        contruction_board: filterBoardHDQT?.contruction_board,
        status: filterBoardHDQT?.status,
        date_issued:
          filterBoardHDQT?.from_issue_date && filterBoardHDQT?.to_issue_date
            ? [
                moment(filterBoardHDQT?.from_issue_date),
                moment(filterBoardHDQT?.to_issue_date),
              ]
            : [],
      })
    }
  }, [filterBoardHDQT, showFilter, setFieldsValue])

  const onFinish = values => {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'string') {
        values[key] = values[key].trim()
      }
    })
    const { date_issued } = values

    if (date_issued && date_issued.length === 2) {
      values.from_issue_date = moment(date_issued[0]).format(ISO_DATE_FORMAT)
      values.to_issue_date = moment(date_issued[1]).format(ISO_DATE_FORMAT)
    }

    boardResolutionMinutesStore.setfilterBoardHDQT({
      page: 1,
      contruction_board: values.contruction_board,
      document_name: values.document_name,
      document_number: values.document_number,
      from_issue_date: values.from_issue_date,
      to_issue_date: values.to_issue_date,
      status: values.status,
      issue_level: values.issue_level,
    })

    onToggleFilter()
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  const options = [
    { label: 'Đã bãi bỏ', value: 'ABOLISHED' },
    { label: 'Hết hiệu lực', value: 'EXPIRED' },
    { label: 'Còn hiệu lực', value: 'ACTIVE' },
    { label: 'Khác', value: 'NEW' },
  ]

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item name={'document_name'} label={'Tên văn bản'}>
                <Input placeholder={'Nhập tên tài liệu'} />
              </Form.Item>
              <Form.Item
                name={'document_number'}
                label={'Số quyết định ban hành'}>
                <Input placeholder={'Nhập số quyết định ban hành'} />
              </Form.Item>
              <Form.Item label={'Ngày ban hành'} name={'date_issued'}>
                <RangePicker
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item name={'issue_level'} label={'Cấp ban hành'}>
                <Input placeholder={'Nhập cấp ban hành'} />
              </Form.Item>
              <Form.Item
                name={'contruction_board'}
                label={'Ban chủ trì xây dựng'}>
                <Input placeholder={'Nhập ban chủ trì xây dựng'} />
              </Form.Item>
              <Form.Item name={'status'} label={'Trạng thái'}>
                <Select
                  showSearch
                  allowClear
                  placeholder="Trạng thái"
                  filterOption={true}
                  optionFilterProp="label">
                  {options.map(opt => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  onToggleFilter()
                  boardResolutionMinutesStore.resetFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

BoardResolutionMinutesPageAdvanceFilterV2.propTypes = {}

export default inject(
  'authorityStore',
  'loadingAnimationStore',
  'boardResolutionMinutesStore'
)(observer(BoardResolutionMinutesPageAdvanceFilterV2))
